import React, { useEffect, useRef } from "react";
import { StyleSheet, Text, View, Dimensions, Animated } from "react-native";
import {
  widthPercentageToDP as wp,
  heightPercentageToDP as hp,
} from "../../../../Utils/responsive";
import {
  riskIntroPageTextMandG,
  buttonText,
} from "../../../../Utils/static-strings";
import ContinueButton from "../../../../Components/ContinueButton";
import "./intro-style.css";
import clockIcon from "../../../../assets/images/clock-regular-full.svg";
const deviceWidth = Dimensions.get("screen").width;
const Index = (props) => {
  const animation = useRef(
    new Animated.Value(-Dimensions.get("screen").width)
  ).current;
  const imageOpacity = useRef(new Animated.Value(0)).current;
  const imageSize = Math.min(430, deviceWidth * 0.35);

  useEffect(() => {
    Animated.parallel([
      Animated.timing(animation, {
        toValue: 0,
        duration: 1000,
        useNativeDriver: false,
      }),
      Animated.timing(imageOpacity, {
        toValue: 1,
        duration: 800,
        useNativeDriver: false,
      }),
    ]).start();
  }, []);
  return (
    <div
      style={{
        height: "100%",
        width: "100%",
        position: "absolute",
        justifyContent: "center",
        alignItems: "center",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Animated.View
        style={{
          width: deviceWidth > 600 ? "82%" : "90%",
          height: "75%",
          justifyContent: "center",
          transform: [{ translateX: animation }],
        }}
      >
        <Text
          style={{
            fontFamily: "var(--font-family-heading)",
            fontSize: 60,
            lineHeight: 68,
            fontWeight: "var(--font-weight-semi-bold)",
            color: "#2f2f2f",
            marginBottom: hp("3%"),
          }}
        >
          Risk
        </Text>
        <Text style={styles.customText}>{riskIntroPageTextMandG}</Text>
        <View
          style={{
            flexDirection: "row",
            marginBottom: hp("3%"),
            // opacity: 0.69,
            height: 18,
          }}
        >
          <img
            src={clockIcon}
            alt=""
            style={{ width: 18, height: 18, objectFit: "contain" }}
          />
          <Text
            style={{
              fontSize: 14,
              fontFamily: "Infra",
              color: "#2f2f2f",
              paddingLeft: 10,
            }}
          >
            Typically 2-3 minutes
          </Text>
        </View>
        <ContinueButton onClick={() => props.Showing()} text={buttonText} />
      </Animated.View>

      <View style={{ height: "25%", width: "100%" }} />

      <Animated.Image
        source={require("../../../../assets/images/mandg/mandg-active-square-atr.png")}
        style={{
          position: "absolute",
          bottom: 0,
          right: 0,
          width: imageSize,
          height: imageSize,
          resizeMode: "contain",
          pointerEvents: "none",
          opacity: imageOpacity,
        }}
      />
    </div>
  );
};
export default Index;
const styles = StyleSheet.create({
  content: {
    height: "100vh", // deviceWidth > 600 ? '85vh' : '88vh',
    width: "100vw",
    // flex: 1,
    justifyContent: "center",
    alignItems: "center",
  },

  customText: {
    width:
      Dimensions.get("screen").width > 1300
        ? wp("60%")
        : Dimensions.get("screen").width > 700
          ? wp("60%")
          : wp("89%"),
    fontSize: 19,
    textAlign: "Left",
    color: "#2f2f2f",
    marginBottom: hp("3%"),
    fontFamily: "Infra",
    lineHeight: 24,
    alignSelf: "flex-start",
  },
});
